import "./comment.scss"

interface IComment {
    profile: string
    name: string
    body: string
    view: string
    time: string
}

const Comment = ({profile, name, body, view, time}: IComment) => {
    return (
        <div className="Comment">
            <img src={profile} alt="" className="img-fluid Comment-Profile"/>
            <div className="Comment-Box">
                <p className="Comment-Box-Name">{name}</p>
                <p className="Comment-Box-Body">{body}</p>
                <div style={{marginTop: '-10px'}}>
                    <span className="Comment-Box-View">
                    {view} views
                    </span>
                    <span className="Comment-Box-Time">{time}</span>
                </div>
            </div>
        </div>
    );
}

export default Comment;